import type { ReactNode } from 'react';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { env } from './env';
import { persister, queryClient, TWENTY_FOUR_HOURS } from './query';

export function QueryProvider({ children }: { children: ReactNode }) {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: TWENTY_FOUR_HOURS,
        buster: env.VITE_APP_VERSION,
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
}
